import React from "react";
import { Widget, WidgetProps } from "@rjsf/utils";

export const TitleWidget: Widget = ({ label }: WidgetProps) => {
  return <h2 className="form-title">{label}</h2>;
};
